import { render, staticRenderFns } from "./ContatoList.vue?vue&type=template&id=aa92c680&scoped=true&"
import script from "./ContatoList.vue?vue&type=script&lang=js&"
export * from "./ContatoList.vue?vue&type=script&lang=js&"
import style0 from "./ContatoList.vue?vue&type=style&index=0&id=aa92c680&prod&scoped=true&lang=css&"
import style1 from "./ContatoList.vue?vue&type=style&index=1&id=aa92c680&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa92c680",
  null
  
)

export default component.exports